import React from 'react';
import PropTypes from 'prop-types';
import ModalContainer from '../Global/Modals/ModalContainer';
import ModalHeader from '../Global/Modals/ModalHeader';

const EditFolderModal = ({ modalIsOpen, onCloseClick, onAfterOpen, children }) => (
  <ModalContainer
    isOpen={modalIsOpen}
    closeModal={onCloseClick}
    label="Edit folder modal"
    onAfterOpen={onAfterOpen}
  >
    <div className="edit-folder-modal">
      <ModalHeader title="Edit folder" onCloseClick={onCloseClick} />
      {children}
    </div>
  </ModalContainer>
);

EditFolderModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onAfterOpen: PropTypes.func,
  children: PropTypes.object.isRequired,
};

export default EditFolderModal;



// WEBPACK FOOTER //
// ./library/app/components/Folders/EditFolderModal.js